import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const RotateIcon = React.forwardRef<SVGSVGElement, Omit<SvgIconProps, 'cacheName'>>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="rotate" ref={ref as any} {...props}>
      <path
        d="M12.3933 4.89534C14.1186 4.89825 15.7882 5.52022 17.1112 6.65285V4H18.4407V9.3886H13.1715V8.02902H16.6248C15.7115 7.11643 14.5391 6.52291 13.2757 6.3335C12.0123 6.14409 10.7227 6.36851 9.59171 6.97462C8.46068 7.58072 7.54628 8.53739 6.97952 9.70755C6.41276 10.8777 6.22273 12.2013 6.43667 13.4887C6.6506 14.7761 7.25751 15.9612 8.17044 16.8742C9.08337 17.7872 10.2555 18.3812 11.5188 18.5712C12.7821 18.7612 14.0718 18.5373 15.2031 17.9318C16.3344 17.3262 17.2492 16.3699 17.8165 15.2L19 15.8052C18.4148 17.0111 17.525 18.035 16.4228 18.7711C15.3207 19.5072 14.0461 19.9286 12.7312 19.9917C11.4163 20.0548 10.1087 19.7573 8.94397 19.1301C7.77922 18.5028 6.79959 17.5686 6.1065 16.424C5.41341 15.2795 5.03206 13.9664 5.00193 12.6205C4.97181 11.2746 5.294 9.94501 5.93515 8.76926C6.5763 7.59351 7.5131 6.6144 8.64857 5.93329C9.78403 5.25217 11.0769 4.89382 12.3933 4.89534Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
});
